import BlankMarketRunnerDetails from "app/components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/BlankMarketRunnerDetails/BlankMarketRunnerDetails";
import ExchangeMarketRunnerDetails from "app/components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/ExchangeMarketRunnerDetails/ExchangeMarketRunnerDetails";
import HomeAwayNASides from "app/components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/HomeAwayNASides/HomeAwayNASides";
import HomeAwaySidesRunner from "app/components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/HomeAwaySides/HomeAwaySides";
import MarketRunnerDetailsBySequence from "app/components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/MarketRunnerDetailsBySequence/MarketRunnerDetailsBySequence";
import RenderPlayerProps from "app/components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/PlayerProps/RenderPlayerProps";
import flatten from "lodash/flatten";
import has from "lodash/has";
import type { Node } from "React";
import BinaryMarketRunnerDetails from "../components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/BinaryMarketRunnerDetails/BinaryMarketRunnerDetails";
import BinaryMarketRunnerDetailsAlt from "../components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/BinaryMarketRunnerDetailsAlt/BinaryMarketRunnerDetailsAlt";
import CorrectScoreMarketRunnerDetails from "../components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/CorrectScoreMarketRunnerDetails/CorrectScoreMarketRunnerDetails";
import MarketRunnerDetailsGrouped from "../components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/MarketRunnerDetailsGrouped/MarketRunnerDetailsGrouped";
import SingleRowMarketRunnerDetails from "../components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/SingleRowMarketRunnerDetails/SingleRowMarketRunnerDetails";
import ThreewayMarketRunnerDetails from "../components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/ThreewayMarketRunnerDetails/ThreewayMarketRunnerDetails";
import ThreewayMarketRunnerDetailsAlt from "../components/UnsummarizedMarketsModal/components/ModalMarkets/components/MarketPeriods/components/components/MarketRunnerDetails/components/ThreewayMarketRunnerDetailsAlt/ThreewayMarketRunnerDetailsAlt";
import type {
  EventMarketPeriodType,
  EventRunnerType,
  EventType,
} from "../types/eventType";
import {
  MarketPeriods,
  MarketTypes,
  RunnerStatus,
  SportsNameType,
} from "../utils/const";
import { MarketsHelper } from "./marketsHelper";

export class marketPeriodHelper {
  static hasMarketPeriodAnyRunners(
    marketPeriod: EventMarketPeriodType
  ): boolean {
    const markts = flatten(
      marketPeriod.marketTypes.map(mt => {
        return mt.markets;
      })
    );
    let found = false;
    let index = 0;

    while (!found && index < markts.length) {
      if (has(markts[index], "runners")) {
        found = true;
      }

      index++;
    }

    return found;
  }

  static getMarketTypeType: (marketType: any) => any | string = (
    marketType: Record<string, any>
  ) => {
    if (
      marketType.marketType === MarketTypes.ONE_X_TWO ||
      marketType.marketType === MarketTypes.CORNER_ONE_X_TWO
    ) {
      return MarketTypes.ONE_X_TWO;
    } else if (
      marketType.marketType === MarketTypes.HANDICAP ||
      marketType.marketType === MarketTypes.CORNER_HANDICAP ||
      marketType.marketType === MarketTypes.TOTAL ||
      marketType.marketType === MarketTypes.SET_HANDICAP ||
      marketType.marketType === MarketTypes.SET_TOTAL ||
      marketType.marketType === MarketTypes.CORNER_TOTAL ||
      marketType.marketType === MarketTypes.MONEY_LINE ||
      marketType.marketType === MarketTypes.TOTAL_KILLS ||
      marketType.marketType === MarketTypes.TOTAL_KILLS_AWAY ||
      marketType.marketType === MarketTypes.TOTAL_KILLS_HOME ||
      marketType.marketType === MarketTypes.MOST_KILLS ||
      marketType.marketType === MarketTypes.HANDICAP_KILLS
    ) {
      return MarketTypes.HANDICAP;
    } else if (marketType.marketType === MarketTypes.CORRECT_SCORE) {
      return MarketTypes.CORRECT_SCORE;
    } else if (marketType && MarketsHelper.isMatchOdds(marketType.marketType)) {
      return MarketTypes.MATCH_ODDS;
    } else return marketType.marketType;
  };

  static getMarketTypeRunnerComponent: (
    type: string,
    marketType: any,
    market: any,
    event: EventType
  ) => Node = (
    type: string,
    marketType: Record<string, any>,
    market: Record<string, any>,
    event: EventType
  ) => {
    // Needs to be refactored https://ns90ltd.atlassian.net/browse/BET-13408
    // Adding TOTAL_ROUNDS_COMPLETED in boxing apart from the rest as I
    // dont want to make the nesting if/elses more nested

    if (
      marketType.marketType === MarketTypes.PLAYER_SCORE_OUTSIDE_AREA ||
      marketType.marketType === MarketTypes.PLAYER_ASSISTS ||
      marketType.marketType === MarketTypes.PLAYER_ASSISTS_2_PLUS ||
      marketType.marketType === MarketTypes.PLAYER_SCORE_AND_ASSIST ||
      marketType.marketType === MarketTypes.PLAYER_SCORE_FREEKICK ||
      marketType.marketType === MarketTypes.PLAYER_SCORE_HEADER ||
      marketType.marketType === MarketTypes.PLAYER_SHOWN_CARD ||
      marketType.marketType === MarketTypes.PLAYER_SHOWN_RED_CARD ||
      marketType.marketType === MarketTypes.BOTH_PLAYERS_SCORE ||
      marketType.marketType === MarketTypes.FIRST_CARDED_TEAM ||
      marketType.marketType === MarketTypes.TOUCHDOWN_SCORER_ANYTIME ||
      marketType.marketType === MarketTypes.PLAYER_TOUCHDOWN_2_PLUS
    ) {
      return (
        <MarketRunnerDetailsGrouped
          market={market}
          marketType={marketType}
          event={event}
          groupedBy={"side"}
        />
      );
    }
    if (
      type === MarketTypes.TOTAL_ROUNDS_COMPLETED &&
      (event.sportType === SportsNameType.BOXING ||
        event.sportType === SportsNameType.MMA)
    ) {
      return (
        <BinaryMarketRunnerDetailsAlt
          market={market}
          marketType={marketType}
          event={event}
        />
      );
    }
    if (type === MarketTypes.HANDICAP || this.getDisplayType(type) === 1) {
      return market && market.runners && market.runners.length > 1 ? (
        <BinaryMarketRunnerDetails
          market={market}
          marketType={marketType}
          event={event}
        />
      ) : null;
    } else if (
      this.getDisplayType(type) === 1 ||
      this.getDisplayType(type) === 3 ||
      this.getDisplayType(type) === 6
    ) {
      if (
        type === MarketTypes.WINNING_MARGIN ||
        type === MarketTypes.FIRST_LAST_GOAL ||
        type.indexOf("GOALSCORER") > -1
      ) {
        return (
          <ThreewayMarketRunnerDetailsAlt
            market={market}
            marketType={marketType}
            event={event}
            columnType={this.getGroupValue(type)}
          />
        );
      } else if (
        type === MarketTypes.BOTH_SCORE_AND_TOTAL ||
        type === MarketTypes.THREE_WAY_AND_TOTAL ||
        type === MarketTypes.THREE_WAY_AND_BOTH_SCORE
      ) {
        return (
          <MarketRunnerDetailsGrouped
            market={market}
            marketType={marketType}
            event={event}
            groupedBy={"type"}
          />
        );
      } else {
        return (
          <BinaryMarketRunnerDetailsAlt
            market={market}
            marketType={marketType}
            event={event}
          />
        );
      }
    } else if (this.getDisplayType(type) === 7) {
      return (
        <ThreewayMarketRunnerDetails
          market={market}
          marketType={marketType}
          event={event}
          displayType={this.getDisplayType(type)}
        />
      );
    } else if (this.getDisplayType(type) === 8) {
      if (type === MarketTypes.MONEYLINE_AND_TOTAL) {
        return (
          <MarketRunnerDetailsGrouped
            market={market}
            marketType={marketType}
            event={event}
            groupedBy={"type"}
          />
        );
      } else if (type === MarketTypes.HIGHEST_SCORING_QUARTER_AND_TEAM) {
        return (
          <MarketRunnerDetailsBySequence
            market={market}
            marketType={marketType}
            event={event}
            numerOfRows={2}
          />
        );
      } else if (
        type === MarketTypes.METHOD_OF_VICTORY ||
        type === MarketTypes.ROUND_BETTING
      ) {
        if (event.sportType === SportsNameType.BOXING) {
          return (
            <HomeAwayNASides
              market={market}
              marketType={marketType}
              event={event}
            />
          );
        }
        return (
          <HomeAwaySidesRunner
            market={market}
            marketType={marketType}
            event={event}
          />
        );
      } else {
        return (
          <SingleRowMarketRunnerDetails
            market={market}
            marketType={marketType}
            event={event}
          />
        );
      }
    } else if (type === MarketTypes.CORRECT_SCORE) {
      if (event.sportType === SportsNameType.TENNIS) {
        return (
          <HomeAwaySidesRunner
            market={market}
            marketType={marketType}
            event={event}
          />
        );
      } else {
        return (
          <CorrectScoreMarketRunnerDetails
            market={market}
            marketType={marketType}
            event={event}
          />
        );
      }
    } else if (type === MarketTypes.TOUCHDOWN_SCORED) {
      return (
        <MarketRunnerDetailsGrouped
          market={market}
          marketType={marketType}
          event={event}
          groupedBy={"type"}
        />
      );
    } else if (
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_1ST ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_2ND ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_3RD ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_4TH ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_5TH ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_6TH ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_7TH ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_8TH ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_9TH ||
      type === MarketTypes.TOUCHDOWN_TEAM_SCORER_10TH ||
      type === MarketTypes.TOUCHDOWN_SCORER_1ST ||
      type === MarketTypes.TOUCHDOWN_SCORER_2ND ||
      type === MarketTypes.TOUCHDOWN_SCORER_3RD ||
      type === MarketTypes.TOUCHDOWN_SCORER_4TH ||
      type === MarketTypes.TOUCHDOWN_SCORER_5TH ||
      type === MarketTypes.TOUCHDOWN_SCORER_6TH ||
      type === MarketTypes.TOUCHDOWN_SCORER_7TH ||
      type === MarketTypes.TOUCHDOWN_SCORER_8TH ||
      type === MarketTypes.TOUCHDOWN_SCORER_9TH ||
      type === MarketTypes.TOUCHDOWN_SCORER_10TH
    ) {
      return (
        <HomeAwayNASides
          market={market}
          marketType={marketType}
          event={event}
        />
      );
    } else if (type === MarketTypes.WINNER_OF_TIE) {
      return (
        <HomeAwaySidesRunner
          market={market}
          marketType={marketType}
          event={event}
        />
      );
      // } else if (type === MarketTypes.MATCH_ODDS) {
    } else if (marketType && MarketsHelper.isMatchOdds(type)) {
      return (
        <ExchangeMarketRunnerDetails
          market={market}
          marketType={marketType}
          event={event}
        />
      );
    } else if (
      // NBA
      type === MarketTypes.PLAYER_TOTAL_POINTS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_ASSISTS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_BLOCKS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_REBOUNDS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_STEALS_ROLLING ||
      // NFL
      type === MarketTypes.PLAYER_TOTAL_RUSHING_YARDS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_RUSHING_ATTEMPTS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_RECEIVING_YARDS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_RECEPTIONS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_PASSING_YARDS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_PASSING_ATTEMPTS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_PASS_COMPLETIONS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_PASSING_TOUCHDOWNS_ROLLING ||
      // NHL
      type === MarketTypes.PLAYER_TOTAL_GOALS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_SHOTS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_ASSISTS_ROLLING ||
      type === MarketTypes.PLAYER_TOTAL_POINTS_ROLLING
    ) {
      return (
        <RenderPlayerProps
          market={market}
          marketType={marketType}
          event={event}
          groupedBy={"type"}
        />
      );
    } else {
      return <BlankMarketRunnerDetails />;
    }
  };
  static getDisplayType: (type: string) => null | number = (type: string) => {
    // Display Type 1
    if (
      type === MarketTypes.TOTAL_HOME ||
      type === MarketTypes.TOTAL_AWAY ||
      type === MarketTypes.TOTAL_GOALS_HOME ||
      type === MarketTypes.TOTAL_GOALS_AWAY ||
      type === MarketTypes.TOTAL_POINTS_HOME ||
      type === MarketTypes.TOTAL_POINTS_AWAY ||
      type === MarketTypes.TOTAL_TOUCHDOWNS ||
      type === MarketTypes.TOTAL_KILLS ||
      type === MarketTypes.TOTAL_KILLS_HOME ||
      type === MarketTypes.TOTAL_KILLS_AWAY ||
      type === MarketTypes.TOTAL_CARDS ||
      type === MarketTypes.TOTAL_CARDS_HOME ||
      type === MarketTypes.TOTAL_CARDS_AWAY
    ) {
      return 1; // Display Type 3
    } else if (
      type === MarketTypes.WINNING_MARGIN ||
      type === MarketTypes.THREE_WAY_AND_TOTAL ||
      type === MarketTypes.THREE_WAY_AND_BOTH_SCORE ||
      type === MarketTypes.FIRST_LAST_GOAL ||
      type === MarketTypes.FIGHT_GOES_DISTANCE ||
      type === MarketTypes.OUTRIGHT ||
      type === MarketTypes.FIRST_CARDED_TEAM ||
      type.indexOf("GOALSCORER") > -1
    ) {
      return 3; // Display type 6
    } else if (
      type === MarketTypes.TOTAL_ODD_EVEN ||
      type === MarketTypes.TOTAL_ODD_EVEN_HOME ||
      type === MarketTypes.TOTAL_ODD_EVEN_AWAY ||
      type === MarketTypes.CLEAN_SHEET ||
      type === MarketTypes.WIN_TO_NIL ||
      type === MarketTypes.DRAW_NO_BET ||
      type === MarketTypes.BOTH_SCORE ||
      type === MarketTypes.BOTH_SCORE_AND_TOTAL ||
      type === MarketTypes.MATCH_TIE
    ) {
      return 6; // Display type 7
    } else if (
      type.indexOf(MarketTypes.WINNER_INTERVAL) > -1 ||
      type === MarketTypes.ONE_X_TWO ||
      type === MarketTypes.TOTAL_ODD_EVEN ||
      type === MarketTypes.HALF_MOST_GOALS ||
      type === MarketTypes.DOUBLE_CHANCE ||
      type === MarketTypes.HALF_FULL_TIME ||
      type === MarketTypes.THREE_WAY ||
      type === MarketTypes.RACE_TO
    ) {
      return 7; // Display type 8
    } else if (
      type === MarketTypes.TOTAL_GOALS ||
      type === MarketTypes.OVERTIME ||
      type === MarketTypes.HIGHEST_SCORING_QUARTER ||
      type === MarketTypes.TEAM_HIGHEST_SCORING_QUARTER ||
      type === MarketTypes.HIGHEST_SCORING_QUARTER_AND_TEAM ||
      type === MarketTypes.LAST_POINT ||
      type === MarketTypes.MONEYLINE_AND_TOTAL ||
      type === MarketTypes.METHOD_OF_VICTORY ||
      type === MarketTypes.ROUND_BETTING
    ) {
      return 8;
    } else {
      return null;
    }
  };
  static marketNameHasHandicap: (type: string) => boolean = (type: string) => {
    if (
      type === MarketTypes.WINNING_MARGIN ||
      type === MarketTypes.THREE_WAY_AND_TOTAL ||
      type === MarketTypes.BOTH_SCORE_AND_TOTAL
    ) {
      return true;
    } else {
      return false;
    }
  };
  // Some markets are grouped by side others by type
  static getGroupValue: (type: string) => string = (type: string) => {
    if (
      type === MarketTypes.WINNING_MARGIN ||
      type === MarketTypes.HALF_FULL_TIME ||
      type === MarketTypes.RACE_TO ||
      type === MarketTypes.ONE_X_TWO ||
      type.indexOf("GOALSCORER") > -1 ||
      type.includes("TOUCHDOWN_SCORER")
    ) {
      return "side";
    } else {
      return "type";
    }
  };
  // Check for whether a runner should be displayed
  static shouldHideRunner: (runner: EventRunnerType) => boolean = (
    runner: EventRunnerType
  ) => {
    const hasPrices =
      runner["aggregatedPrices"] && runner["aggregatedPrices"].length > 0;
    const isRunnerClosed =
      (runner && runner.status === RunnerStatus.CLOSED) ||
      runner.status === RunnerStatus.GRADED;
    return !hasPrices || isRunnerClosed;
  };

  // Check for whether the market period name should be displayed along with market name
  static showMarketPeriodName: (marketPeriod: string) => boolean = (
    marketPeriod: string
  ) => {
    return (
      marketPeriod === MarketPeriods.FIRST_HALF ||
      marketPeriod === MarketPeriods.SECOND_HALF ||
      marketPeriod === MarketPeriods.EXTRA_TIME ||
      marketPeriod === MarketPeriods.FIRST_FIVE_INNINGS ||
      marketPeriod === MarketPeriods.FIRST_PERIOD ||
      marketPeriod === MarketPeriods.SECOND_PERIOD ||
      marketPeriod === MarketPeriods.THIRD_PERIOD ||
      marketPeriod === MarketPeriods.FOURTH_PERIOD ||
      marketPeriod.includes("MAP_")
    );
  };

  // Check for whether the market quarter name should be displayed along with market name
  static showMarketQuarterName: (marketPeriod: string) => boolean = (
    marketPeriod: string
  ) => {
    return (
      marketPeriod === MarketPeriods.FIRST_QUARTER ||
      marketPeriod === MarketPeriods.SECOND_QUARTER ||
      marketPeriod === MarketPeriods.THIRD_QUARTER ||
      marketPeriod === MarketPeriods.FOURTH_QUARTER
    );
  };

  // BET-11036
  // Correct Score runner name has participant name included
  //  in the format: "2 - 1 [Dan Evans]"
  // Need to remove this for displaying in single event view
  // and leave it for displaying in betslip, reports etc
  // There will be a DI/API ticket to change this behaviour.
  static formatRunnerName(name: string): string {
    const runnerNameIncludesParticipantName = name.indexOf("[");
    const runnerName =
      runnerNameIncludesParticipantName === -1
        ? name
        : name.substring(0, runnerNameIncludesParticipantName);
    return runnerName;
  }

  // Temporary check until new event details screen is done for euro and mobile
  static isEuroMarket: (type: string) => boolean = (type: string) => {
    if (
      type === MarketTypes.TOTAL_GOALS_HOME ||
      type === MarketTypes.TOTAL_GOALS_AWAY ||
      type === MarketTypes.WINNING_MARGIN ||
      type === MarketTypes.THREE_WAY_AND_TOTAL ||
      type === MarketTypes.THREE_WAY_AND_BOTH_SCORE ||
      type === MarketTypes.FIRST_LAST_GOAL ||
      type === MarketTypes.CORRECT_SCORE ||
      type === MarketTypes.TOTAL_ODD_EVEN ||
      type === MarketTypes.CLEAN_SHEET ||
      type === MarketTypes.WIN_TO_NIL ||
      type === MarketTypes.DRAW_NO_BET ||
      type === MarketTypes.BOTH_SCORE ||
      type === MarketTypes.BOTH_SCORE_AND_TOTAL
    ) {
      return false;
    } else {
      return true;
    }
  };
}
